import { SystemItemTypes } from "../enums";

export class RelatedItemsGridModel {
    public id: string;
    public name: string;
    public type: keyof typeof SystemItemTypes;
    public oneTimePrice: string;
    public recurringPrice: string;
    public priceOrvariant: string;
    constructor(data: Partial<RelatedItemsGridModel> = {}) {
        this.id = data.id || '';
        this.name = data.name || '';
        this.type = data.type || SystemItemTypes.Product;
        this.oneTimePrice = data.oneTimePrice || '';
        this.recurringPrice = data.recurringPrice || '';
        this.priceOrvariant = data.priceOrvariant || '';
    }
}
